const textFieldFormActions = {
  actionText: 'Action',
  problemText: 'Problem',
};

export default textFieldFormActions;
